import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupCompleteMessage: {
    defaultMessage:
      'Setup complete! Your Advanced ShipStation Notice is pending review, contact your ShipStation account manager to complete onboarding and finish sending your inventory. This review is only necessary for your first inventory shipment and will unlock the rest of the Fulfilled by ShipStation functionality.',
    id: '6t3Aj+',
    description: 'Success message shown when setup is completed',
  },
  resourcesTitle: {
    defaultMessage: 'Resources',
    id: 'CaiUX0',
    description: 'Title for the resources section',
  },
  uploadProductsTitle: {
    defaultMessage: 'Upload products',
    id: 'F2iOx3',
    description: 'Title for upload products resource card',
  },
  uploadProductsDescription: {
    defaultMessage: 'Make sure all products to be Fulfilled by ShipStation are uploaded in ShipStation.',
    id: 'EJ/I+8',
    description: 'Description for upload products resource card',
  },
  importProductsButton: {
    defaultMessage: 'Import products',
    id: '2393HH',
    description: 'Button text for importing products',
  },
  selectLocationTitle: {
    defaultMessage: 'Select a Fulfilled by ShipStation location',
    id: 'rNMsxl',
    description: 'Title for select location resource card',
  },
  selectLocationDescription: {
    defaultMessage: 'Select a location that would best serve your customers needs.',
    id: 'pV+KrC',
    description: 'Description for select location resource card',
  },
  learnMoreFBSLocationsButton: {
    defaultMessage: 'Learn more about FBS Locations',
    id: 'b5M7gM',
    description: 'Button text for learning about FBS locations',
  },
  prepareProductsTitle: {
    defaultMessage: 'Prepare your products',
    id: '3JfRWN',
    description: 'Title for prepare products resource card',
  },
  prepareProductsDescription: {
    defaultMessage: 'Each product should have a clear barcode label for the warehouse to scan.',
    id: 'emzE7j',
    description: 'Description for prepare products resource card',
  },
  reviewRequirementsButton: {
    defaultMessage: 'Review requirements',
    id: '8WyPTi',
    description: 'Button text for reviewing requirements',
  },
  sendInventoryTitle: {
    defaultMessage: 'Send inventory to the warehouse',
    id: 'IjRQj2',
    description: 'Title for send inventory resource card',
  },
  sendInventoryDescription: {
    defaultMessage: 'Create your Advance Shipping Notice (ASN), print receiving labels, and ship.',
    id: 'taat4Z',
    description: 'Description for send inventory resource card',
  },
  createAdvancedShippingNoticeButton: {
    defaultMessage: 'Create an Advanced Shipping Notice',
    id: 'jTHELd',
    description: 'Button text for creating advanced shipping notice',
  },
  learnOrderRoutingTitle: {
    defaultMessage: 'Learn about order routing',
    id: 'xGsx9d',
    description: 'Title for learn order routing resource card',
  },
  learnOrderRoutingDescription: {
    defaultMessage: 'Review order routing to prepare for your review session.',
    id: 'pSStSW',
    description: 'Description for learn order routing resource card',
  },
  learnMoreOrderRoutingButton: {
    defaultMessage: 'Learn more about Order Routing',
    id: 'S7Es+M',
    description: 'Button text for learning about order routing',
  },
  scheduleReviewTitle: {
    defaultMessage: 'Schedule a review session',
    id: 'TR5GGI',
    description: 'Title for schedule review resource card',
  },
  scheduleReviewDescription: {
    defaultMessage: 'Review your ASNs, Order Routing selections, and more with a ShipStation rep.',
    id: 'EP+BMo',
    description: 'Description for schedule review resource card',
  },
  scheduleReviewButton: {
    defaultMessage: 'Schedule Review',
    id: '55sE86',
    description: 'Button text for scheduling review',
  },
});
